module.exports = __webpack_public_path__ + "static/media/mb.0046e508.mp4";